import { ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/atoms/dropdown-menu';
import { cn } from '@/lib/utils';

interface StatusOption {
  value: string;
  label: string;
}

interface EntityListStatusDropdownProps {
  value: string;
  options: StatusOption[];
  dotColors: Record<string, string>;
  onChange: (value: string) => void;
  allValue?: string;
}

export function EntityListStatusDropdown({
  value,
  options,
  dotColors,
  onChange,
  allValue = 'all',
}: EntityListStatusDropdownProps) {
  const activeLabel = options.find((o) => o.value === value)?.label ?? 'All';
  const isFiltered = value !== allValue;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            'flex h-8 shrink-0 items-center gap-1 rounded-md border px-2.5 text-xs font-medium transition-colors',
            isFiltered
              ? 'border-primary/40 bg-primary/10 text-primary'
              : 'border-border bg-background text-muted-foreground hover:bg-accent hover:text-foreground',
          )}
        >
          {activeLabel}
          <ChevronDown size={11} className="opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {options.map((o) => (
          <DropdownMenuItem
            key={o.value}
            onSelect={() => onChange(o.value)}
            className={cn(value === o.value && 'bg-accent')}
          >
            <span className="flex items-center gap-2">
              {o.value !== allValue && (
                <span
                  className={cn(
                    'h-2 w-2 shrink-0 rounded-full',
                    dotColors[o.value] ?? 'bg-gray-400',
                  )}
                />
              )}
              {o.label}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
